module.exports = __webpack_public_path__ + "static/slide4-d51e8d6eb4383f411e78fa22c0b718d6.png";